import React from 'react'

import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import DirectPurchaseLinkSection from '../components/directPurchaseLinkSection';


export default function DirectPurchaseLink() {

    const {email} = useParams();
       
    return (
        <>
                <InactivityLogout>
                <Header searchterm={email} />
                <DirectPurchaseLinkSection searchterm={email} />
                </InactivityLogout>
        </>
    );
}